export default "__VITE_ASSET__BwuhSFX$__"